import { useMediaQuery, useTheme } from '@material-ui/core'
import { Cancel } from '@material-ui/icons'
import React from 'react'
import {
  Edit,
  EditProps,
  ListButton,
  SaveButton,
  SimpleForm,
  TextField,
  TextInput,
  Toolbar,
  ToolbarProps,
  useTranslate,
} from 'react-admin'
import { DeviceManagementContainerDto } from '../../../core/dto/device/device-management/device-management-containers/DeviceManagementContainer.dto'
import FilteredReferenceInput from '../../common/FilteredReferenceInput'
import { ResourceName } from '../../../core/ResourceName'

const validateTSCanEdit = (values: DeviceManagementContainerDto) => {
  const errors: { [n: string]: string } = {}
  if (!values.name) {
    errors.name = 'ra.validation.required'
  }
  return errors
}

const EditTitle = () => {
  const translate = useTranslate()
  return (
    <span>
      {translate('resources.device-management-containers.titles.edit')}
    </span>
  )
}

const EditToolbar = (props: ToolbarProps) => (
  <Toolbar {...props}>
    <SaveButton />
    <ListButton icon={<Cancel />} label="const.cancel" />
  </Toolbar>
)

export const DeviceManagementContainerEdit = (props: EditProps) => {
  const theme = useTheme()
  const smallScreen = useMediaQuery(theme.breakpoints.down('sm'))

  return (
    <Edit {...props} title={<EditTitle />}>
      <SimpleForm
        redirect="show"
        validate={validateTSCanEdit}
        toolbar={<EditToolbar />}
      >
        <TextField source="id" label="ID" />
        <TextInput source="name" isRequired />
        <FilteredReferenceInput
          source="backgroundImageId"
          reference={ResourceName.FILES}
          sort={{ field: 'name', order: 'ASC' }}
          perPage={smallScreen ? 5 : 15}
          allowEmpty
          filterSource="name"
          selectWithPaginationInputProps={{
            optionText: 'name',
            showFilter: true,
          }}
          filter={{
            fileExtension: '.jpg,.png,.jpeg,.svg',
          }}
        />
        <FilteredReferenceInput
          source="parentId"
          reference={ResourceName.DEVICE_MANAGEMENT_CONTAINERS}
          sort={{ field: 'name', order: 'ASC' }}
          perPage={smallScreen ? 5 : 15}
          allowEmpty
          filterSource="name"
          selectWithPaginationInputProps={{
            optionText: 'name',
            showFilter: true,
          }}
        />
      </SimpleForm>
    </Edit>
  )
}
